export type FieldErrors = Record<string, string[]>;

export interface ApiRejectPayload {
  message: string;
  fieldErrors?: FieldErrors;
}

export const getApiErrorPayload = (error: any): ApiRejectPayload => {
  const data = error?.response?.data;

  if (data?.errors) {
    return {
      message:
        data?.message ||
        data?.errors?.message?.[0] ||
        data?.errors?.email?.[0] ||
        "Request failed.",
      fieldErrors: data.errors,
    };
  }

  return {
    message: data?.message || error?.message || "Request failed.",
  };
};
